import CTAButtonWrapper from './CTAButtonWrapper';

export default CTAButtonWrapper;
